import type { FilterDropdownOption } from '@/shared/ui/FilterDropdown';

import { CONNECTOR_STATUS_FILTER_VALUES, type ConnectorStatusFilterValue } from '@/entities/connector';

export const ACTIVATION_FILTER_OPTIONS: FilterDropdownOption<string>[] = [
  { key: 'active', label: 'Activation', value: 'active' },
  { key: 'inactive', label: 'Deactivation', value: 'inactive' },
];

export const STATUS_FILTER_OPTIONS: FilterDropdownOption<ConnectorStatusFilterValue>[] = [
  { key: 'success', label: 'Success', value: CONNECTOR_STATUS_FILTER_VALUES.SUCCESS },
  { key: 'failure', label: 'Failure', value: CONNECTOR_STATUS_FILTER_VALUES.FAILURE },
  { key: 'empty', label: '-', value: CONNECTOR_STATUS_FILTER_VALUES.EMPTY },
];
